module.exports = __webpack_public_path__ + "img/image-button-send-offering.599b1aa6.png";